var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "collection-total-results" }, [
    _c("div", { staticClass: "collection-total-result body-sm font-italic" }, [
      _vm._v(_vm._s(_vm.currentTotal) + " " + _vm._s(_vm.results))
    ]),
    _vm.currentFilters && _vm.currentFilters.length > 0
      ? _c(
          "div",
          {
            staticClass:
              "collection-total-result collection-total-result-filters"
          },
          [
            _c("span", { staticClass: "body-sm font-italic" }, [
              _vm._v(
                _vm._s(_vm.currentFilters.length) + " " + _vm._s(_vm.filters)
              )
            ]),
            _vm.currentFilters.length && _vm.$mq == "mobile"
              ? _c(
                  "v-link",
                  {
                    staticClass: "clear-all body-sm",
                    attrs: { secondary: true },
                    on: { click: _vm.removeAllFilters }
                  },
                  [_vm._v("Clear All")]
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }